import { Button, ButtonProps } from "antd";
import { useAntTheme } from "hooks/useAntTheme";
import { useTranslate } from "#src/hooks";

export const EditButton = ({
  item,
  ...props
}: ButtonProps & { item: string }) => {
  const { theme } = useAntTheme();
  const t = useTranslate();

  return (
    <Button
      type="text"
      shape="round"
      {...props}
      style={{
        backgroundColor: theme.colorBgLayout,
        color: theme.colorTextBase,
        ...props.style,
      }}
    >
      {t("components.templates.settings.changeButton", { item })}
    </Button>
  );
};
